/**
 * Filters for location option lists used in the wizard.
 *
 * Signature, title, and date location dropdowns share a common set of
 * physical locations. Some options are context-specific:
 * - "Not on Object" applies to titles and signatures, NOT dates (#786)
 * - "Not Dated on Object" applies to dates, NOT titles/signatures (#826)
 */

const DATE_EXCLUDED_OPTIONS = ['Not on Object'];
const TITLE_AND_SIGNATURE_EXCLUDED_OPTIONS = ['Not Dated on Object'];

/**
 * Filter signature locations for use in the date location dropdown.
 * Removes options that only apply to titles/signatures.
 */
export const filterDateLocations = (locations: readonly string[]): string[] =>
  locations.filter((loc) => !DATE_EXCLUDED_OPTIONS.includes(loc));

/**
 * Filter signature locations for use in the title and signature dropdowns.
 * Removes options that only apply to dates.
 */
export const filterTitleAndSignatureLocations = (locations: readonly string[]): string[] =>
  locations.filter((loc) => !TITLE_AND_SIGNATURE_EXCLUDED_OPTIONS.includes(loc));
